import { ArrowLeft, DollarSign, Mail } from 'lucide-react'
import { Button } from '@/components/ui/Button'

const SUPPORT_EMAIL = 'admin@monumenta.com.br'

export function GerencialAccessRestricted() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] space-y-6">
      <DollarSign className="h-16 w-16 text-brand-red" />
      <h1 className="text-3xl font-bold text-white font-display">Acesso Restrito</h1>
      <p className="text-brand-gray-light text-center max-w-md font-body text-lg">
        Esta área contém informações financeiras sensíveis e está disponível apenas para usuários autorizados.
      </p>
      <div className="flex gap-3">
        <Button
          variant="ghost"
          size="md"
          onClick={() => window.history.back()}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Voltar
        </Button>
        <Button
          variant="primary"
          size="md"
          onClick={() => {
            const subject = encodeURIComponent('Solicitação de acesso ao Fluxo Gerencial')
            window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}`
          }}
        >
          <Mail className="w-4 h-4 mr-2" />
          Solicitar acesso
        </Button>
      </div>
    </div>
  )
}
